<template>
  <div class="system-select">
    <strong>System</strong>
    <select v-model="signSystem">
      <option v-for="s in signSystems" :value="s.name" :key="s.index">{{ s.label }}</option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SignSystems } from '../utils/signs'

export default {
  name: 'SignSystem',
  computed: {
    ...mapGetters(['getSignSystem']),
    signSystems () {
      return SignSystems
    },
    signSystem: {
      get () {
        return this.getSignSystem
      },
      set (value) {
        this.$store.commit('changeSignSystem', { system: value })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.system-select {
  display: flex;
  justify-content: space-between;
}
</style>
